@if (shouldShowBanner()) {
  <div class="promo-banner" [routerLink]="[bannerLink()]" role="button" tabindex="0">
    <div class="banner-content">
      <div class="counter-badge">
        {{ promotionsCount() }}
      </div>
      <span class="banner-text">{{ bannerText() }}</span>
    </div>

    <button
      mat-icon-button
      type="button"
      class="close-button"
      (click)="onDismiss($event)"
      aria-label="Dismiss banner">
      <ac-icon iconKey="hr:xmark" [size]="16" />
    </button>
  </div>
}
